import React, { Component } from 'react'
import './game.css'
import { get } from '../../ajax/tools'
import PopUp from '../round/PopUp'
import { withRouter } from 'react-router-dom'
class GameSignUpIco extends Component {
  constructor(props) {
    super(props)
    this.state = {
      GameSignUpIcoArr: [],
      GameSignUpIcoArrLength: null,
      GameSignUpIcoErr: '',
      GameSignAllArr: [],
      PopUpPassword: '',
      isYouthPage: false,
      signBtnWord: '青少赛报名',
    }
  }
  componentDidMount = function () {
    const search = this.props.location.search
    const queryParams = new URLSearchParams(search)
    const type = queryParams.get('type')

    if (type === 'Y') {
      this.setState({
        isYouthPage: true,
      })
      get({ url: 'match/get_match_youth' }).then((res) => {
        if (res.errno === '200') {
          this.setState({
            GameSignUpIcoArr: res.data.filter(
              (i) => !i.match_name.includes('test')
            ),
            GameSignUpIcoArrLength: res.data.filter(
              (i) => !i.match_name.includes('test')
            ).length,
            GameSignAllArr: res.data,
          })
        } else {
          this.setState({
            GameSignUpIcoErr: 'Err',
          })
        }
      })
    } else {
      this.setState({
        isYouthPage: false,
      })
      get({ url: 'match/get_match' }).then((res) => {
        if (res.errno === '200') {
          this.setState({
            GameSignUpIcoArr: res.data.filter(
              (i) => !i.match_name.includes('test')
            ),
            GameSignUpIcoArrLength: res.data.filter(
              (i) => !i.match_name.includes('test')
            ).length,
            GameSignAllArr: res.data,
          })
        } else {
          this.setState({
            GameSignUpIcoErr: 'Err',
          })
        }
      })
    }
  }
  getYouthGame() {
    if (this.state.signBtnWord === '青少赛报名') {
      get({ url: 'match/get_match_youth' }).then((res) => {
        if (res.errno === '200') {
          this.setState({
            GameSignUpIcoArr: res.data.filter(
              (i) => !i.match_name.includes('test')
            ),
            GameSignUpIcoArrLength: res.data.filter(
              (i) => !i.match_name.includes('test')
            ).length,
            GameSignAllArr: res.data,
            signBtnWord: '全部赛事',
            GameSignUpIcoErr: '',
          })
        } else {
          this.setState({
            GameSignUpIcoErr: 'Err',
            signBtnWord: '全部赛事',
            GameSignAllArr: [],
            GameSignUpIcoArr: [],
          })
        }
      })
    } else if (this.state.signBtnWord === '全部赛事') {
      get({ url: 'match/get_match' }).then((res) => {
        if (res.errno === '200') {
          this.setState({
            GameSignUpIcoArr: res.data.filter(
              (i) => !i.match_name.includes('test')
            ),
            GameSignUpIcoArrLength: res.data.filter(
              (i) => !i.match_name.includes('test')
            ).length,
            GameSignAllArr: res.data,
            signBtnWord: '青少赛报名',
            GameSignUpIcoErr: '',
          })
        } else {
          this.setState({
            GameSignUpIcoErr: 'Err',
            signBtnWord: '青少赛报名',
            GameSignAllArr: [],
            GameSignUpIcoArr: [],
          })
        }
      })
    }
  }

  GameSignUpIcoBtn = (item, index) => {
    let ClickInfo = {
      GameId: item.id,
      GameName: item.match_name,
      GameNum: item.team_limit_man_num,
      GameType: item.enroll_type,
    }
    this.props.GameSignUpIco(ClickInfo)
  }

  ShowProcess() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'http://oss.asfcyy.com/richTextImage/22fd070efe8811ec9dc800163e3521a2.pdf'
    )
    a.setAttribute('target', '_blank')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }

  ShowProcessNet() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'http://oss.asfcyy.com/richTextImage/8349d9b6fe8811ec9dc800163e3521a2.mp4'
    )
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'FS')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }
  ShowProcessNet2() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'https://oss.asfcyy.com/richTextImage/96eaefe633ea11f186f800163e44221c.pdf'
    )
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'FS')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }
  ShowProcessVerb() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'http://oss.asfcyy.com/richTextImage/f8826b0a031d11ed9dc800163e3521a2.pdf'
    )
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'FS')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }
  ShowProcessList() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'https://oss.asfcyy.com/richTextImage/d1b7039432f011f1adee00163e44221c.docx'
    )
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'FS')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }
  ShowPAsk() {
    let a = document.createElement('a')
    a.setAttribute(
      'href',
      'https://oss.asfcyy.com/richTextImage/b9d1340838ad11f1998700163e44221c.pdf'
    )
    a.setAttribute('target', '_blank')
    a.setAttribute('download', 'FS')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)
  }
  showGameTest() {
    this.setState({
      PopUpPassword: '',
      PopUp: 'sb',
    })
  }
  CrossOutTwo() {
    this.setState({
      PopUp: '',
    })
  }
  PopUpPassword(event) {
    this.setState({
      PopUpPassword: event.target.value,
    })
  }
  goToYounthPage() {
    window.open('http://yg.asfcyy.com')
  }
  PopUpBtn() {
    if (this.state.PopUpPassword === 'asfcyy') {
      let GameSignAllArr = this.state.GameSignAllArr
      this.setState({
        PopUp: '',
        GameSignUpIcoArr: GameSignAllArr,
        GameSignUpIcoArrLength: GameSignAllArr.length,
      })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '密码错误！',
      })
    }
  }
  //弹窗点击的逻辑处理
  ChildBackClick = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div
        className={'GameMainBox scrollBar'}
        style={{ height: window.innerHeight - 191 }}
      >
        <div
          className={'InfoListPositionTitBox'}
          style={{ height: 50, position: 'relative' }}
        >
          {/*<div className={'InfoListPositionTit'} style={{float:'left',marginLeft:30,marginTop:10,}}>*/}
          {/*    <div className={'InfoListPosition'}>选择赛事</div>*/}
          {/*</div>*/}
          <div
            className={'InfoListPositionTit'}
            style={{ float: 'left', marginLeft: 30, marginTop: 10 }}
          >
            <div className={'InfoListPosition'}>
              点击查看{' '}
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowProcess.bind(this)}
              >
                参赛报名流程
              </span>
            </div>
            <div
              className={'InfoListPosition'}
              style={{
                textAlign: 'right',
                marginTop: 4,
                position: 'relative',
                zIndex: '9898',
              }}
            >
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowProcessList.bind(this)}
              >
                参赛组队附表
              </span>
            </div>
          </div>
          <div
            className={'InfoListPositionTit'}
            style={{ float: 'left', marginLeft: 30, marginTop: 10 }}
          >
            <div className={'InfoListPosition'}>
              点击查看{' '}
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowProcessNet.bind(this)}
              >
                全国赛网赛视频拍摄流程
              </span>
            </div>
            <div
              className={'InfoListPosition'}
              style={{
                textAlign: 'right',
                marginTop: 4,
                position: 'relative',
                zIndex: '9898',
              }}
            >
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowProcessNet2.bind(this)}
              >
                参赛视频录制及上传要求
              </span>
            </div>
          </div>
          <div
            className={'InfoListPositionTit'}
            style={{ float: 'left', marginLeft: 30, marginTop: 10 }}
          >
            <div className={'InfoListPosition'}>
              点击查看{' '}
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowProcessVerb.bind(this)}
              >
                全国赛解说口才线上参赛须知
              </span>
            </div>
            <div
              className={'InfoListPosition'}
              style={{
                textAlign: 'right',
                marginTop: 4,
                position: 'relative',
                zIndex: '9898',
                marginRight: 80,
              }}
            >
              <span
                style={{ color: '#FB621E', textDecoration: 'underline' }}
                onClick={this.ShowPAsk.bind(this)}
              >
                知识竞赛答题说明
              </span>
            </div>
          </div>
          <div
            className={'GameSignShowTestButton'}
            onClick={() => this.showGameTest()}
          ></div>
        </div>

        {this.state.isYouthPage && (
          <div className={'InfoListPositionTitBox'}>
            <div
              style={{
                fontSize: 20,
                color: '#fff',
                fontWeight: 600,
                textAlign: 'center',
                marginTop: 10,
                cursor: 'pointer',
                width: 200,
                marginLeft: 30,
                borderRadius: 5,
                background: '#409EFF',
                height: 30,
                lineHeight: '30px',
              }}
              onClick={() => this.goToYounthPage()}
            >
              青少赛专题页面{' '}
            </div>
          </div>
        )}

        {this.state.GameSignUpIcoArrLength !== 0 &&
          this.state.GameSignUpIcoArrLength !== null && (
            <div
              className={'GameSignUpIcoBoxes clearfix'}
              style={{ position: 'relative' }}
            >
              {!this.state.isYouthPage && (
                <div
                  className={'InfoListPositionTitBox'}
                  style={{ position: 'absolute', width: 'auto', left: -65 }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      color: '#fff',
                      fontWeight: 600,
                      textAlign: 'center',
                      marginTop: 10,
                      cursor: 'pointer',
                      width: 150,
                      borderRadius: 5,
                      background: '#409EFF',
                      height: 30,
                      lineHeight: '30px',
                    }}
                    onClick={() => this.getYouthGame()}
                  >
                    {this.state.signBtnWord}{' '}
                  </div>
                </div>
              )}
              {this.state.GameSignUpIcoArr.map((item, index) => (
                <div className={'GameSignUpIcoBox'} key={index}>
                  <div
                    className={'GameSignUpIco'}
                    onClick={() => this.GameSignUpIcoBtn(item, index)}
                  >
                    {' '}
                  </div>
                  <div className={'GameSignUpIcoTitle'} style={{ width: 360 }}>
                    {item.match_name}
                  </div>
                </div>
              ))}
            </div>
          )}
        {this.state.GameSignUpIcoArrLength === 0 && (
          <div className={'NotGameTip'}>
            <div className={'TrainDataMain'}>
              <div
                className={'GameYearNum'}
                style={{ position: 'unset', fontSize: 54 }}
              >
                当前未有赛事活动！
              </div>
            </div>
          </div>
        )}
        {this.state.GameSignUpIcoErr === 'Err' && (
          <div className={'NotGameTip'}>
            <div className={'TrainDataMain'}>
              <div
                className={'GameYearNum'}
                style={{ position: 'unset', fontSize: 54 }}
              >
                当前未有赛事活动！
              </div>
            </div>
          </div>
        )}
        {this.state.PopUp === 'sb' && (
          <div className={'PopUpBoxBg'} style={{ minHeight: 200 }}>
            <div className={'AddItemBox'} style={{ width: 400, height: 290 }}>
              <div className={'AddItemBigTitle'}>
                <div
                  className={'AddItemBackIco'}
                  onClick={this.CrossOutTwo.bind(this)}
                >
                  {' '}
                </div>
              </div>
              <div
                className={'AddInfoMainBox'}
                style={{ width: 400, height: 236 }}
              >
                <div className={'PopUpTipsWord'}>
                  请输入测试密码进行二次验证：
                </div>
                <div className={'PopUpInputBox'}>
                  <input
                    className={'PopUpInput'}
                    type={'password'}
                    name={'PopUpInput'}
                    value={this.state.PopUpPassword}
                    onChange={this.PopUpPassword.bind(this)}
                    placeholder={'请输入测试密码二次验证'}
                    autoComplete={'new-password'}
                  />
                </div>
                <div className={'PopUpBtn'} onClick={this.PopUpBtn.bind(this)}>
                  确认
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackClick.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'No'}
          />
        )}
        {}
      </div>
    )
  }
}

export default withRouter(GameSignUpIco)
